import { createElementVNode as _createElementVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-64ccd4ef"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "background-div" }, null, -1))
const _hoisted_2 = { class: "image__container" }
const _hoisted_3 = ["src"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _hoisted_1,
    _createElementVNode("p", {
      onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('close'))),
      class: "link-2"
    }, " close "),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("img", {
        src: _ctx.img,
        alt: ""
      }, null, 8, _hoisted_3)
    ])
  ], 64))
}